import i18next from 'i18next';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import BreadCrumbs from '../../components/BreadCrumbs/BreadCrumbs';
import Paper from '@material-ui/core/Paper';
import React, { useEffect } from 'react';
import './VersionPageTranslate';
import { versionPageModule, clearState, loadData, setData } from './VersionPageDucks';
import { Form as FormikForm, Formik } from 'formik';
import Row from '../../_ui/Row';
import Input from '../../_ui/Input/Input';
import JustCheckbox from '../../_ui/Checkbox/Checkbox';
import Button from '../../_ui/Button/Button';
import SaveIcon from '@material-ui/icons/Save';
import { VersionUpdateSchema } from './VersionValidation';

export default function() {
  const breadCrumbItems = [
    { name: i18next.t('breadcrumbs_home'), href: '/' },
    { name: i18next.t('breadcrumbs_versionMp') }
  ];
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();

  const loading = useSelector(state => state[versionPageModule].loading);
  const data = useSelector(state => state[versionPageModule].data);
  useEffect(() => {
    dispatch(loadData());
    return () => {
      dispatch(clearState());
    };
  }, []);

  const handelSubmit = data => {
    dispatch(setData(data));
  };
  return (
    <>
      <BreadCrumbs items={breadCrumbItems} />
      <Paper className={'pb3 pt1 px3'}>
        <h3>{t('versionPage_title')}</h3>
        <div>
          <Formik
            enableReinitialize
            initialValues={data}
            onSubmit={values => handelSubmit(values)}
            validationSchema={VersionUpdateSchema}
          >
            {({ values }) => (
              <FormikForm>
                <Row label={t('versionPage_androidVersion')}>
                  <Input
                    name="androidVersion"
                    placeholder={t('versionPage_androidVersion')}
                    className="fullwidth"
                  />
                </Row>
                <Row label={t('versionPage_critical')}>
                  <JustCheckbox name="isAndroidCritical" />
                </Row>
                <Row label={t('versionPage_iosVersion')}>
                  <Input
                    name="iosVersion"
                    placeholder={t('versionPage_iosVersion')}
                    className="fullwidth"
                  />
                </Row>
                <Row label={t('versionPage_critical')}>
                  <JustCheckbox name="isIosCritical" />
                </Row>
                <div className="mt1">
                  <Button
                    icon={<SaveIcon fontSize="small" className="mr1" />}
                    type="submit"
                    text={t('versionPage_save')}
                    loading={loading}
                    disabled={loading}
                  />
                </div>
              </FormikForm>
            )}
          </Formik>
        </div>
      </Paper>
    </>
  );
}
